export default "__VITE_ASSET__a5862067__"